import { FC } from "react";
import { PostMatchSurveyPage } from "../pages";

const SurveyRoute: FC<{}> = () => {

    return <PostMatchSurveyPage />
}

export default SurveyRoute;